import { PageMeta } from "src/components";
import { appConfig } from "src/config";
import { useTranslate } from "src/i18n";

import { KnowledgeIndex } from "./components";
import { useKnowledgeBaseOutletContext } from "./useKnowledgeBaseOutletContext";

export const KnowledgeBaseSections = () => {
  const { t } = useTranslate();
  const { basePath, route, tree } = useKnowledgeBaseOutletContext();

  const title = t("knowledge_base.meta.title", "База знаний — {displayName}", {
    displayName: appConfig.displayName,
  });
  const description = t(
    "knowledge_base.meta.description",
    "Документация, инструкции и ответы на частые вопросы по работе с {displayName}.",
    { displayName: appConfig.displayName },
  );

  return (
    <>
      {route === "base" && (
        <PageMeta title={title} description={description} path={basePath} />
      )}

      <KnowledgeIndex basePath={basePath} tree={tree} />
    </>
  );
};
